import session from '../../auth_api/session'
import Vue from 'vue'

const URL = process.env.VUE_APP_API_URL
const URLImportFile = URL + 'gku_reestr/api/'

export default {
  namespaced: true,
  state: {
    listFiles: { 'results': [] },
    exportListFiles: { 'results': [] },
    processStatuses: [],
    fileType: []
  },
  mutations: {
    setListFiles (state, payload) {
      state.listFiles = payload
    },
    setExportListFiles (state, payload) {
      state.exportListFiles = payload
    },
    setFile (state, payload) {
      Vue.set(state.listFiles.results, payload.index, payload.data)
    },
    pushFile (state, payload) {
      state.listFiles.results.push(payload)
    },
    setProcessStatuses (state, payload) {
      state.processStatuses = payload
    },
    setFileType (state, payload) {
      state.fileType = payload
    }
  },
  actions: {
    fetchListFiles ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'fetchListFiles', { root: true })
        let params = {}
        if (0 + payload.pageId > 1) {
          params['page'] = payload.pageId
        }
        if (payload.period > '') {
          params['period'] = payload.period
        }
        let _url = URLImportFile + 'import-file/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListFiles', response.data)
            commit('common/popLoading', 'fetchListFiles', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchListFiles', { root: true })
            reject(e)
          })
      })
    },
    fetchExportListFiles ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'fetchExportListFiles', { root: true })
        let params = {}
        if (0 + payload.pageId > 1) {
          params['page'] = payload.pageId
        }
        if (payload.period > '') {
          params['period'] = payload.period
        }

        let _url = URLImportFile + 'export-file/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setExportListFiles', response.data)
            commit('common/popLoading', 'fetchExportListFiles', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchExportListFiles', { root: true })
            reject(e)
          })
      })
    },
    fetchFileType ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'fetchFileType', { root: true })
        let _url = URLImportFile + 'import-file-type-reestr/'
        session.get(_url)
          .then(response => {
            commit('setFileType', response.data.results)
            commit('common/popLoading', 'fetchFileType', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchFileType', { root: true })
            reject(e)
          })
      })
    },
    fetchProcessStatuses ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'fetchProcessStatuses', { root: true })
        let _url = URLImportFile + 'import-file-process-status/'
        session.get(_url)
          .then(response => {
            commit('setProcessStatuses', response.data.results)
            commit('common/popLoading', 'fetchProcessStatuses', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchProcessStatuses', { root: true })
            reject(e)
          })
      })
    },
    insertFile ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'insertFile_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URLImportFile + 'import-file/'
        const data = new FormData()
        data.append('file_path', payload.file)
        data.append('month', payload.month)
        data.append('year', payload.year)
        data.append('ogrn', payload.ogrn)
        if (payload.note) {
          data.append('note', payload.note)
        }
        if (payload.status) {
          data.append('status', payload.status)
        }
        session.post(_url, data,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('pushFile', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deleteFile ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'deleteFile', { root: true })
        let _url = URLImportFile + 'import-file/' + payload.data.id + '/cancel_processing/'
        session.get(_url)
          .then(response => {
            commit('setFile', { index: payload.index, data: response.data })
            commit('common/popLoading', 'deleteFile', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'deleteFile', { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    listFiles (state) {
      return state.listFiles
    },
    exportListFiles (state) {
      return state.exportListFiles
    },
    processStatuses (state) {
      return state.processStatuses
    },
    getProcessStatuses: (state) => (status) => {
      let processStatus = { 'name': '' }
      for (let i in state.processStatuses) {
        if (state.processStatuses[i]['id'] === status) {
          processStatus = state.processStatuses[i]
          break
        }
      }
      return processStatus
    },
    fileType (state) {
      return state.fileType
    },
    getFileType: (state) => (statusType) => {
      let type = { 'name': '' }
      for (let i in state.fileType) {
        if (state.fileType[i]['id'] === statusType) {
          type = state.fileType[i]
          break
        }
      }
      return type
    }
  }
}
